var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 7.94,
    viewBox: "0 0 14 7.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-caret-up",
    "data-name": "Icon awesome-caret-up",
    d: "M13.851,12.891H1.738A.941.941,0,0,0,1.072,14.5l6.057,6.057a.942.942,0,0,0,1.331,0L14.517,14.5A.941.941,0,0,0,13.851,12.891Z",
    transform: "translate(-0.794 -12.891)",
    fill: "#cb3d47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.1af3da0e46851e801331f79ff339c2b5.svg";
export { ForwardRef as ReactComponent };